import React, { useEffect, useState } from "react"
import { beautifyMsToHMSString, DAY_IN_MS } from "../../utility/common/time"
import { SelectedOperatorStatus } from "../../models/operatorStatus"
import { testId } from "../../utility/tests/testId/menu"
import { useTranslation } from "react-i18next"

const tNamespace = "operator"

export interface OperatorStatusTimerProps {
    status: SelectedOperatorStatus
}

const OperatorStatusTimer: React.FC<OperatorStatusTimerProps> = ({ status }) => {
    const { t } = useTranslation(tNamespace)
    const [elapsedTime, setElapsedTime] = useState(0)

    const prevStatusTimestamp = status.StatusSetTime ?? Date.now()

    useEffect(() => {
        const updateTimer = () => {
            const ms = Date.now() - prevStatusTimestamp

            setElapsedTime(Math.max(0, ms))
        }

        updateTimer()

        const timerId = setInterval(updateTimer, 1000)

        return () => {
            if (timerId) {
                clearInterval(timerId)
            }
        }
    }, [prevStatusTimestamp])

    return (
        <div data-testid={testId.operatorStatusTimer}>
            {elapsedTime > DAY_IN_MS ? t("timer-more-than-day") : beautifyMsToHMSString(elapsedTime)}
        </div>
    )
}

export default OperatorStatusTimer
